import { Injectable } from '@angular/core';

export interface DeviceInfo {
  deviceId: string;
  platform: string;
  deviceName: string;
}

/**
 * Fase 2 (sesiones) — identidad de dispositivo para el login.
 * Genera y persiste un `deviceId` estable en localStorage (una vez por navegador)
 * y expone la plataforma y un nombre legible para el panel de sesiones.
 */
@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private readonly STORAGE_KEY = 'avz_device_id';

  getDeviceInfo(): DeviceInfo {
    return {
      deviceId: this.getDeviceId(),
      platform: 'web',
      deviceName: this.getDeviceName(),
    };
  }

  private getDeviceId(): string {
    let id = localStorage.getItem(this.STORAGE_KEY);
    if (!id) {
      id = this.generateUuid();
      localStorage.setItem(this.STORAGE_KEY, id);
    }
    return id;
  }

  private generateUuid(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    // Fallback (navegadores sin crypto.randomUUID / contextos no seguros).
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /** Etiqueta legible mínima (navegador + SO) derivada del user-agent. */
  private getDeviceName(): string {
    const ua = navigator.userAgent || '';
    const browser =
      /Edg\//.test(ua) ? 'Edge'
      : /OPR\//.test(ua) ? 'Opera'
      : /Chrome\//.test(ua) ? 'Chrome'
      : /Firefox\//.test(ua) ? 'Firefox'
      : /Safari\//.test(ua) ? 'Safari'
      : 'Navegador';
    const os =
      /Windows/.test(ua) ? 'Windows'
      : /Mac OS X|Macintosh/.test(ua) ? 'macOS'
      : /Android/.test(ua) ? 'Android'
      : /iPhone|iPad|iOS/.test(ua) ? 'iOS'
      : /Linux/.test(ua) ? 'Linux'
      : '';
    return os ? `${browser} en ${os}` : browser;
  }
}
